import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App.tsx'

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

const urlParams = new URLSearchParams(window.location.search);
let emmid: number | undefined;
if (urlParams.has('emmid')) {
    emmid = Number(urlParams.get('emmid'));
} else {
    const emmidStr = prompt('Map id');
    if (emmidStr != null && Number.isInteger(Number(emmidStr))) {
        urlParams.set("emmid", emmidStr!);
        window.location.search = urlParams.toString();
    }
}

const filePath = urlParams.get('file') || undefined;

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App emmid={emmid} filePath={filePath} />
    </React.StrictMode>,
)
